import { createSetPropMutation, createClearPropMutation } from '@/store/utils';
import * as types from '@/store/request/mutationTypes';

export default {
  [types.SET_REQUESTS]: createSetPropMutation('requests', []),
  [types.CLEAR_REQUESTS]: createClearPropMutation('requests', []),
  [types.SET_REQUESTS_LIST_OPTIONS](state, options = {}) {
    state.requestListOptions = {
      ...state.requestListOptions || {},
      ...options,
    };
  },
};
